<template>
  <thead>
    <tr class="d-flex" ref="header">
      <slot name="table-header"></slot>

      <th
        v-for="(item, i) in sizedColumns"
        :key="item.column"
        @click="setSort(i)"
        class="py-1 px-2 table-cell"
        :style="item.style"
        style="cursor: pointer"
        :class="{
          'drag-handle':
            enableSortable &&
            (!dragDisabledOnColumns ||
              !dragDisabledOnColumns.includes(variables[i])),
          'last-header-cell': i === sizedColumns.length - 1,
        }"
        :data-column="item.column"
        :data-columnvar="variables[i]"
      >
        <span>
          <i
            style="cursor: pointer"
            @click="setSort(i)"
            v-if="tooltip ? Object.entries(tooltip).length !== 0 : false"
            class="fa fa-info-circle icon-custom mr-1"
            :title="tooltip[item.column]"
          ></i>
          <template v-if="inputActive">
            <input
              type="text"
              class="form-control input-custom"
              value="1"
              v-if="inputActive[item.column]"
              @click.stop
              @input="changeFilterInput(item.column, $event)"
            />
          </template>
          <span
            style="cursor: pointer"
            @click="setSort(i)"
            v-html="item.column"
          ></span>
          <SortingOptions
            v-if="enableSortBySpecificColumn"
            :active-sort="variables[i] === sort ? order : null"
          />
        </span>

        <div
          v-if="enableColumnResize"
          class="bordered ignore-element"
          @pointerdown="(evt) => pointerDown(evt, i, variables[i])"
        ></div>
      </th>
    </tr>
  </thead>
</template>

<script>
import SortingOptions from "./SortingOptions.vue";

import resizeMixin from "./resize-mixin";
import sortableMixin from "./sortable-mixin";

export default {
  name: "ComposableTableTheadComponent",
  mixins: [resizeMixin, sortableMixin],
  components: {
    SortingOptions,
  },
  props: {
    columns: Array,
    tooltip: {
      type: Object,
      required: false,
    },
    inputActive: {
      type: Object,
      required: false,
    },
    dragDisabledOnColumns: Array,
    variables: Array,
    sort: String,
    order: String,
    enableSortBySpecificColumn: Boolean,
  },
  methods: {
    changeFilterInput(target, event) {
      if (this.resizing) return;

      this.$emit("set-filter", {
        target,
        value: event.target.value,
      });
    },
    setSort(index) {
      if (this.resizing) return;

      const newSort = this.variables[index];
      const order = this.order;

      this.$emit("set-sort", newSort);
      this.$emit(
        "set-order",
        this.sort !== newSort ? "asc" : order === "asc" ? "desc" : "asc"
      );
    },
  },
};
</script>

<style scoped>
tr + tr {
  border-top: 1px solid hsla(0, 0%, 78.4%, 0.4);
}

tr {
  border-bottom: 1px solid hsla(0, 0%, 78.4%, 0.4);
}

th,
tr {
  flex-basis: 100%;
}

th {
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: normal;
  min-width: 75px;
  font-size: 14px;
  padding: 10px 0 !important;
  padding-left: 12px !important;
  border-bottom: 1px solid #efeff0;
  background-color: white;
}

.last-header-cell {
  min-width: 175px;
}

th + th {
  border-left: 1px solid #efeff0;
}

thead th + th {
  border-left: 1px solid #dee2e6;
}

.bordered {
  position: absolute;
  right: 0px;
  top: 0px;
  margin-right: -1px;
  height: 100%;
  width: 5px;
  z-index: 10;
  cursor: col-resize;
  background-color: rgba(0, 0, 0, 0.099);
  opacity: 0;
  transform: translateX(0px) scaleY(1);
  transition-duration: 0.075s;
}

.table-cell {
  font-size: 13px !important;
  font-weight: 400 !important;
}

.bordered:hover {
  opacity: 1;
  width: 10px;
  transform: translateX(3px) scaleY(1.3);
}

.input-custom {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-right: 5px;
  padding: 0 6px;
}

.icon-custom {
  color: #6d6e71;
}
</style>
